import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n/i18n';

export enum KitElement {
  SHIRT = 'shirt',
  SHORTS = 'shorts',
  SOCKS = 'socks',
  CAP = 'cap',
  HELMET = 'helmet',
}

/** Human-readable labels for kit elements. */
export const KIT_ELEMENT_LABELS: Record<KitElement, MessageDescriptor> = {
  [KitElement.SHIRT]: msg`Футболка`,
  [KitElement.SHORTS]: msg`Шорты`,
  [KitElement.SOCKS]: msg`Гетры`,
  [KitElement.CAP]: msg`Кепка`,
  [KitElement.HELMET]: msg`Шлем`,
};
